<template>
    <span>
        <fa-icon :icon="['fas', 'star']" transform="shrink-1" class="text-teal mr-1" /><b class="bolder">{{ Number(rating.toFixed(2)) }}</b>
        <span v-if="numberOfRatings > 0"> ({{ numberOfRatings }})</span>
    </span>
</template>

<script>
export default {
    name: 'StarRating',
    props: {
        rating: {
            type: Number,
            required: true,
        },
        numberOfRatings: {
            type: Number,
            default: () => 0
        },
    },
};
</script>